import React, { FC } from 'react';
import { useTranslations } from '../../../../../hooks/useTranslationsHelper';
import { activePromoStatuses, ParsedPromo } from '../../types';
import { checkIsContentOnlyPromo } from '../../utils';
import { useAuth } from 'react-oidc-context';

interface CardCTASectionProps {
  onClaimClick?: () => void;
  onViewDetailsClick?: () => void;
  showPrimary?: boolean;
  showSecondary?: boolean;
  promo: ParsedPromo;
  isActivePromotions?: boolean;
}

export const CardCTASection: FC<CardCTASectionProps> = ({
  onClaimClick,
  onViewDetailsClick,
  showPrimary = true,
  showSecondary = true,
  promo,
}): JSX.Element | null => {
  const { t } = useTranslations();
  const { isAuthenticated } = useAuth();

  const promoCTA = promo.ctaCopy || t('promotions.button.active-cta.text');

  const loggedOutCTACopy = promo.magicXSlug ? t('promotions.button.opt-in.text') : promoCTA;
  const loggedInCTACopy =
    activePromoStatuses.includes(String(promo.status)) || checkIsContentOnlyPromo(promo)
      ? promoCTA
      : t('promotions.button.opt-in.text');

  // Always show primary CTA for Network promotions even if they are only content based
  const primaryCTAText = isAuthenticated ? loggedInCTACopy : loggedOutCTACopy;

  const handleClaimClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onClaimClick?.();
  };

  const handleViewDetailsClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onViewDetailsClick?.();
  };

  return (
    <div className="promotion-card__cta-section">
      <div className="promotion-card__buttons">
        {showPrimary && (
          <button className="promotion-card__btn promotion-card__btn--primary" onClick={handleClaimClick}>
            {primaryCTAText}
          </button>
        )}

        {showSecondary && (
          <button className="promotion-card__btn promotion-card__btn--secondary" onClick={handleViewDetailsClick}>
            {t('promotions.button.more-info.text')}
          </button>
        )}
      </div>
    </div>
  );
};
